import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import { CONFIG } from './constants';
export var Logger = /*#__PURE__*/function () {
  function Logger() {
    _classCallCheck(this, Logger);
  }
  _createClass(Logger, null, [{
    key: "format",
    value: function format() {
      for (var _len = arguments.length, messages = new Array(_len), _key = 0; _key < _len; _key++) {
        messages[_key] = arguments[_key];
      }
      return ['[ttvc]'].concat(messages, ['::', performance.now()]);
    }

    /** Log a debug message to the console */
  }, {
    key: "debug",
    value: function debug() {
      var _console;
      if (!CONFIG.DEBUG) {
        return;
      }
      // eslint-disable-next-line no-console
      (_console = console).debug.apply(_console, _toConsumableArray(this.format.apply(this, arguments)));
    }

    /** Log a message to the console */
  }, {
    key: "info",
    value: function info() {
      var _console2;
      if (!CONFIG.DEBUG) {
        return;
      }
      // eslint-disable-next-line no-console
      (_console2 = console).info.apply(_console2, _toConsumableArray(this.format.apply(this, arguments)));
    }

    /** Log a warning message to the console */
  }, {
    key: "warn",
    value: function warn() {
      var _console3;
      if (!CONFIG.DEBUG) {
        return;
      }
      // eslint-disable-next-line no-console
      (_console3 = console).warn.apply(_console3, _toConsumableArray(this.format.apply(this, arguments)));
    }
  }]);
  return Logger;
}();